/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconBenefits = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      width={size}
      height={size}
      {...rest}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16.924 11.132a5 5 0 1 0-4.056 5.792M3 12a9 9 0 1 0 9-9m-1 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z" />
    </svg>
  );
};
export default IconBenefits;
